var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 8,
    fill: "url(#paint0_linear_713_8311)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8125 56.5C55.4327 56.5 55.125 56.8077 55.125 57.1875V61.3125C55.125 61.6923 55.4327 62 55.8125 62H59.9375C60.3173 62 60.625 61.6923 60.625 61.3125V57.1875C60.625 56.8077 60.3173 56.5 59.9375 56.5H55.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.375 57.1875C63.375 56.8077 63.6827 56.5 64.0625 56.5H68.1875C68.5673 56.5 68.875 56.8077 68.875 57.1875V61.3125C68.875 61.6923 68.5673 62 68.1875 62H64.0625C63.6827 62 63.375 61.6923 63.375 61.3125V57.1875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8125 37.25C33.4328 37.25 33.125 37.5578 33.125 37.9375V42.0625C33.125 42.4422 33.4328 42.75 33.8125 42.75H37.9375C38.3172 42.75 38.625 42.4422 38.625 42.0625V37.9375C38.625 37.5578 38.3172 37.25 37.9375 37.25H33.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.375 37.9375C41.375 37.5578 41.6828 37.25 42.0625 37.25H46.1875C46.5673 37.25 46.875 37.5578 46.875 37.9375V42.0625C46.875 42.4422 46.5673 42.75 46.1875 42.75H42.0625C41.6828 42.75 41.375 42.4422 41.375 42.0625V37.9375Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8125 45.5C33.4328 45.5 33.125 45.8077 33.125 46.1875V50.3125C33.125 50.6923 33.4328 51 33.8125 51H37.9375C38.3172 51 38.625 50.6923 38.625 50.3125V46.1875C38.625 45.8077 38.3172 45.5 37.9375 45.5H33.8125Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.375 46.1875C41.375 45.8077 41.6828 45.5 42.0625 45.5H46.1875C46.5673 45.5 46.875 45.8077 46.875 46.1875V50.3125C46.875 50.6923 46.5673 51 46.1875 51H42.0625C41.6828 51 41.375 50.6923 41.375 50.3125V46.1875Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8125 53.75C33.4328 53.75 33.125 54.0577 33.125 54.4375V58.5625C33.125 58.9423 33.4328 59.25 33.8125 59.25H37.9375C38.3172 59.25 38.625 58.9423 38.625 58.5625V54.4375C38.625 54.0577 38.3172 53.75 37.9375 53.75H33.8125Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.375 54.4375C41.375 54.0577 41.6828 53.75 42.0625 53.75H46.1875C46.5673 53.75 46.875 54.0577 46.875 54.4375V58.5625C46.875 58.9423 46.5673 59.25 46.1875 59.25H42.0625C41.6828 59.25 41.375 58.9423 41.375 58.5625V54.4375Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 30.375C28.2406 30.375 27.625 30.9906 27.625 31.75V70.25C27.625 71.0093 28.2406 71.625 29 71.625H73C73.7593 71.625 74.375 71.0093 74.375 70.25V51C74.375 50.2407 73.7593 49.625 73 49.625H52.375V31.75C52.375 30.9906 51.7593 30.375 51 30.375H29ZM52.375 52.375V68.875H59.25V65.4375C59.25 65.0577 59.5577 64.75 59.9375 64.75H64.0625C64.4423 64.75 64.75 65.0577 64.75 65.4375V68.875H71.625V52.375H52.375ZM49.625 33.125H30.375V68.875H37.25V62.6875C37.25 62.3077 37.5578 62 37.9375 62H42.0625C42.4422 62 42.75 62.3077 42.75 62.6875V68.875H49.625V33.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_8311",
    x1: 3.77016,
    y1: 50.9999,
    x2: 102.206,
    y2: 50.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompany);
export default __webpack_public_path__ + "static/media/defaultCompany.b0e86119c7417681aa675930cfa6dfbc.svg";
export { ForwardRef as ReactComponent };